const ROUTES = {
  Home: '/home',
  Admin: '/admin',
  Login: '/login',
  Complete: '/complete',
  InvalidAccount: '/invalid-account',
  TimeRegistration: '/time-registration',
  ParkingReservation: '/park-reservation',
  Report: '/report',
};

export { ROUTES };
